import { render } from "./SeekaBrandSetupRequest.vue?vue&type=template&id=59271590&scoped=true&ts=true"
import script from "./SeekaBrandSetupRequest.vue?vue&type=script&lang=ts"
export * from "./SeekaBrandSetupRequest.vue?vue&type=script&lang=ts"

import "../styles/tailwind-generated.css?vue&type=style&index=0&id=59271590&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59271590"]])

export default __exports__